var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentFile,{tag:"component",attrs:{"data":_vm.data,"position":_vm.position,"layoutName":_vm.layoutName}})
}
var staticRenderFns = []

export { render, staticRenderFns }